<script setup lang="ts">

</script>

<template>
  <div class="mx-4 flex justify-between  overflow-x-auto md:overflow-x-auto lg:overflow-hidden">
    <slot></slot>
  </div>
</template>
<style scoped>
</style>
